module.exports = __webpack_public_path__ + "img/eh.1be062b8.svg";